/* Cart drawer extras: top bar (CSS-only), countdown, upsell slider, reviews carousel.
   Loaded globally; uses MutationObserver on #cart so it re-initializes every time the
   cart drawer content gets replaced via innerHTML (which is how this theme refreshes it). */
(function () {
  'use strict';

  var CART_EL_ID = 'cart';
  var STORAGE_KEY_TIMER = 'cd_timer_end_at';

  // --- helpers ---
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function parseLocalDateString(str) {
    // Accepts "YYYY-MM-DD HH:MM" or "YYYY-MM-DD" - parsed in visitor local time
    if (!str) return null;
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    var d = new Date(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      m[4] ? parseInt(m[4], 10) : 0,
      m[5] ? parseInt(m[5], 10) : 0,
      0
    );
    return isNaN(d.getTime()) ? null : d;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDuration(totalSeconds) {
    if (totalSeconds < 0) totalSeconds = 0;
    var d = Math.floor(totalSeconds / 86400);
    var h = Math.floor((totalSeconds % 86400) / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    if (d > 0) return d + 'j ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  // --- COUNTDOWN ---
  var timerInterval = null;
  function initCountdown(root) {
    if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
    var el = root.querySelector('.cd-timer');
    if (!el) return;
    var clockEl = el.querySelector('.cd-timer__clock');
    if (!clockEl) return;

    var mode = el.getAttribute('data-mode') || 'duration';
    var endAt;

    if (mode === 'date') {
      var dt = parseLocalDateString(el.getAttribute('data-end-date'));
      if (!dt) { el.style.display = 'none'; return; }
      endAt = dt.getTime();
    } else {
      // duration mode: persistent end timestamp in localStorage
      var durationSec = parseInt(el.getAttribute('data-duration'), 10) || 0;
      if (durationSec <= 0) { el.style.display = 'none'; return; }
      var stored = null;
      try { stored = parseInt(localStorage.getItem(STORAGE_KEY_TIMER), 10); } catch (e) {}
      var now = Date.now();
      if (!stored || isNaN(stored) || stored <= now) {
        stored = now + durationSec * 1000;
        try { localStorage.setItem(STORAGE_KEY_TIMER, String(stored)); } catch (e) {}
      }
      endAt = stored;
    }

    function tick() {
      var remaining = Math.floor((endAt - Date.now()) / 1000);
      if (remaining <= 0) {
        clockEl.textContent = '00:00:00';
        clearInterval(timerInterval);
        timerInterval = null;
        if (mode === 'duration') {
          try { localStorage.removeItem(STORAGE_KEY_TIMER); } catch (e) {}
        }
        el.classList.add('cd-timer--ended');
        return;
      }
      clockEl.textContent = formatDuration(remaining);
    }
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  // --- SWIPERS ---
  var upsellSwiper = null;
  var reviewsSwiper = null;

  function destroySwipers() {
    try { if (upsellSwiper && upsellSwiper.destroy) upsellSwiper.destroy(true, true); } catch (e) {}
    try { if (reviewsSwiper && reviewsSwiper.destroy) reviewsSwiper.destroy(true, true); } catch (e) {}
    upsellSwiper = null;
    reviewsSwiper = null;
  }

  function initUpsellSlider(root) {
    if (typeof Swiper === 'undefined') return;
    var wrap = root.querySelector('.cd-upsell__swiper');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.swiper-slide').length;
    if (slides === 0) return;

    upsellSwiper = new Swiper(wrap, {
      slidesPerView: 2.2,
      spaceBetween: 10,
      navigation: {
        prevEl: wrap.querySelector('.cd-upsell__nav--prev'),
        nextEl: wrap.querySelector('.cd-upsell__nav--next')
      },
      breakpoints: {
        420: { slidesPerView: 2.4, spaceBetween: 12 },
        600: { slidesPerView: 3, spaceBetween: 14 }
      },
      watchOverflow: true
    });
  }

  function initReviewsSlider(root) {
    if (typeof Swiper === 'undefined') return;
    var box = root.querySelector('.cd-reviews');
    if (!box) return;
    var wrap = box.querySelector('.cd-reviews__swiper');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.swiper-slide').length;
    if (slides === 0) return;

    var autoplayOn = box.getAttribute('data-autoplay') === '1' && slides > 1;
    var speed = parseInt(box.getAttribute('data-autoplay-speed'), 10) || 3000;

    var opts = {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: slides > 1,
      navigation: {
        prevEl: wrap.querySelector('.cd-reviews__nav--prev'),
        nextEl: wrap.querySelector('.cd-reviews__nav--next')
      },
      pagination: {
        el: wrap.querySelector('.cd-reviews__dots'),
        clickable: true
      },
      watchOverflow: true
    };
    if (autoplayOn) {
      opts.autoplay = { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true };
    }
    reviewsSwiper = new Swiper(wrap, opts);
  }

  // --- ADD TO CART for upsell cards ---
  function bindUpsellAddButtons(root) {
    var buttons = root.querySelectorAll('.cd-upsell__add[data-cd-add-variant]:not(.cd-bound)');
    if (!buttons.length) return;
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.classList.add('cd-bound');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-loading') || btn.classList.contains('is-done') || btn.disabled) return;
        var vid = parseInt(btn.getAttribute('data-cd-add-variant'), 10);
        if (!vid) return;

        btn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: vid, quantity: 1 }],
            sections: 'side-cart'
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          btn.classList.remove('is-loading');
          if (response && response.status && response.status >= 400) {
            btn.classList.add('is-error');
            setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
            return;
          }
          btn.classList.add('is-done');
          // Trigger the theme's own cart refresh path
          if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
            if (response && response.sections) {
              window.ajaxCart.load(response, true, false, false);
            } else {
              window.ajaxCart.load(false, true, false, true);
            }
          } else {
            // Fallback: hard-refresh page so cart state matches
            setTimeout(function () { window.location.reload(); }, 600);
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
        });
      });
    });
  }

  // --- main init ---
  function initAll() {
    var root = document.getElementById(CART_EL_ID);
    if (!root) return;
    destroySwipers();
    initCountdown(root);
    initUpsellSlider(root);
    initReviewsSlider(root);
    bindUpsellAddButtons(root);
  }

  function setup() {
    var root = document.getElementById(CART_EL_ID);
    if (!root) return;
    // Initial pass (will no-op if empty)
    initAll();
    // Re-init whenever drawer contents are replaced
    try {
      var mo = new MutationObserver(function () { initAll(); });
      mo.observe(root, { childList: true, subtree: false });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
